import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppSettings } from 'src/app/app.settings';
import { SharedService } from 'src/app/shared/shared.service';
import { MasterService } from '../../master.service';
import { emailValidator } from '../../../../theme/utils/app-validators';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-contractor-dialog',
  templateUrl: './contractor-dialog.component.html',
  styleUrls: ['./contractor-dialog.component.scss']
})
export class ContractorDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  public moduleNameList = ['Invoice', 'Workorder', 'PRN', 'GRN', 'BOQ'];
  public states = [];
  districtList = [];
  talukaList = [];
  selectedIndex = 0;

  constructor(public formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ContractorDialogComponent>,
    private masterService: MasterService, public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data, private sharedService: SharedService,
    public appSettings: AppSettings) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      'contractorKey': [null],
      'contactPerson': ['', [Validators.pattern(this.appSettings.namePattern)]],
      'contactPersonNo': ['', [Validators.pattern(this.appSettings.mobileNumber)]],
      'contractorName': ['', [Validators.required, Validators.pattern(this.appSettings.namePattern)]],
      'emailId': ['', [emailValidator]],
      'ifscCode': ['', [Validators.pattern(this.appSettings.ifscPattern)]],
      'panNo': ['', [Validators.required, Validators.pattern(this.appSettings.pancard)]],
      'status': ['ACTIVE'],
      'tdsPer': [''],
      'accountNo': [''],
      'addressLine1': [''],
      'addressLine2': [''],
      'city': [''],
      'district': ['', Validators.required],
      'pincode': ['', [Validators.pattern(this.appSettings.pincode)]],
      'state': ['', Validators.required],
      'taluka': ['', Validators.required],
    });
    this.getAllStates();
    if (this.data) {
      this.getDistrictByStateId({ value: this.data?.address?.state });
      this.getTalukaByDistId(this.data.address.district);
      this.form.controls.contractorKey.setValue(this.data.contractorKey);
      this.form.controls.contactPerson.setValue(this.data.contactPerson);
      this.form.controls.contactPersonNo.setValue(this.data.contactPersonNo);
      this.form.controls.contractorName.setValue(this.data.contractorName);
      this.form.controls.emailId.setValue(this.data.emailId);
      this.form.controls.ifscCode.setValue(this.data.ifscCode);
      this.form.controls.panNo.setValue(this.data.panNo);
      this.form.controls.status.setValue(this.data.status);
      this.form.controls.tdsPer.setValue(this.data.tdsPer);
      this.form.controls.accountNo.setValue(this.data.accountNo);
      this.form.controls.addressLine1.setValue(this.data.address.addressLine1);
      this.form.controls.addressLine2.setValue(this.data.address.addressLine2);
      this.form.controls.city.setValue(this.data.address.city);
      this.form.controls.pincode.setValue(this.data.address.pincode);
      this.form.controls.state.setValue(this.data.address.state);
      this.form.controls.district.setValue(this.data.address.district);
      this.form.controls.taluka.setValue(this.data.address.taluka);
    }else{
      this.form.controls.state.setValue(15);
      this.getDistrictByStateId({ value: 15 });
    }
  }

  // getAllDistrict() {
  //   this.sharedService.getAllDist().subscribe(data => {
  //     this.districtList = data;
  //   });
  // }
  getAllStates() {
    this.sharedService.getAllStates().subscribe(data => {
      this.states = data;
    });
  }

  getDistrictByStateId(stateEvent) {
    this.sharedService.getDistrict(stateEvent.value).subscribe(data => {
      this.districtList = data;
    });
  }

  getTalukaByDistId(distId) {
    this.sharedService.getTaluka(distId).subscribe(data => {
      this.talukaList = data;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent) {
    this.selectedIndex = tabChangeEvent.index;
}

public nextStep() {
    this.selectedIndex = this.selectedIndex + 1;
}

public previousStep() {
    this.selectedIndex = this.selectedIndex - 1;
}

}
